import React, { useCallback, useEffect, useState } from 'react';
import { InputSelect } from '~/components/NovosInputs';
import { useTela } from '~/components/OrderTelas/OrderTelasContext';
import { errorHandler } from '~/utils/ErrorHandler';
import { Select } from '../../../protocols';
import api from '~/services/api';
import { SubModulo } from '~/components/OrderTelas/protocols/Modulo';

export const SubModulosContainer: React.FC<{ cod_modulo: number }> = ({
  cod_modulo,
}) => {
  const [subModulos, setSubModulos] = useState<Select[]>([]);
  const { formTela } = useTela();
  const { register, formState, control, setValue } = formTela;
  const { errors } = formState;

  // Ordenar os módulos em ordem alfabética
  const sortedModulos = React.useMemo(
    () =>
      subModulos
        .slice()
        .sort((a, b) =>
          a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }),
        ),
    [subModulos],
  );

  const getSubModulos = useCallback(async (codModulo: number) => {
    try {
      const res = await api.get(`/modulo/sub-modulo/${codModulo}`);
      const { data, success, message } = res.data;
      if (!success) {
        throw new Error(message);
      }
      const regs = data.map((item: SubModulo) => {
        return {
          value: item.cod_seq_modulo_secao,
          label: `${item.des_modulo_secao}`,
        };
      });
      setSubModulos(regs);
    } catch (e: any) {
      errorHandler(e);
    }
  }, []);

  useEffect(() => {
    if (!cod_modulo) {
      return setValue('cod_modulo_secao', null);
    }
    getSubModulos(cod_modulo);
  }, [cod_modulo, setValue, getSubModulos]);

  return (
    <>
      <InputSelect
        label="SubMódulo"
        placeholder="- Selecione o Submódulo -"
        name="cod_modulo_secao"
        register={register}
        isError={!!errors.cod_modulo_secao}
        control={control}
        options={sortedModulos}
        changeSelected={(selected) => setValue('cod_modulo_secao', selected)}
      />
    </>
  );
};
